export const cellFormatting = () => {
  return '';
};
